import React from 'react';

const Wind = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="wind_icon"
    viewBox="0 0 50 35"
  >
    <g fill="#6E7273" fillRule="evenodd" strokeWidth="1.5">
      <path
        stroke="#FFF"
        d="M32.938 7.027a6.042 6.042 0 0 1-3.272 5.385H1v-.123h28.635a5.917 5.917 0 0 0 3.183-5.262c0-3.199-2.515-5.81-5.64-5.902l-.149-.003h-.021c-.044 0-.086 0-.128.003-3.145.068-5.682 2.69-5.682 5.902a5.115 5.115 0 0 0 .01.334c.004.079.01.157.018.235 0 .01 0 .021.002.03.005.05.012.097.018.145h-.122a6.064 6.064 0 0 1-.047-.744c0-3.324 2.66-6.027 5.93-6.027 3.27 0 5.931 2.703 5.931 6.027"
      />
      <path
        stroke="#27AAE1"
        d="M32.938 27.877a6.042 6.042 0 0 0-3.272-5.385H1v.122h28.635a5.917 5.917 0 0 1 3.183 5.263c0 3.199-2.515 5.81-5.64 5.902l-.149.002h-.021c-.044 0-.086 0-.128-.002-3.145-.069-5.682-2.69-5.682-5.902a5.114 5.114 0 0 1 .01-.334 7.71 7.71 0 0 1 .018-.235c0-.01 0-.021.002-.03.005-.05.012-.097.018-.145h-.122c-.03.243-.047.491-.047.744 0 3.323 2.66 6.027 5.93 6.027 3.27 0 5.931-2.704 5.931-6.027"
      />
      <path
        stroke="#FFF"
        d="M48.909 12.209c0 2.518-1.388 4.702-3.406 5.764H1v-.164l44.47.033c1.965-1.044 3.313-3.177 3.313-5.633 0-3.425-2.617-6.219-5.87-6.318a6.149 6.149 0 0 0-.155-.003h-.022c-.045 0-.09 0-.133.003-3.274.073-5.915 2.88-5.915 6.318a5.63 5.63 0 0 0 .01.358c.005.083.012.167.02.251 0 .01 0 .022.002.033.005.052.012.103.018.154h-.126a6.671 6.671 0 0 1-.05-.796c0-3.558 2.77-6.452 6.174-6.452 3.403 0 6.173 2.894 6.173 6.452"
      />
    </g>
  </svg>
);

export default Wind;
